import { SocialPlatform } from '@/lib/api';

const PLATFORM_COLORS: Record<SocialPlatform, string> = {
  twitter: 'bg-black text-white',
  linkedin: 'bg-blue-700 text-white',
  facebook: 'bg-blue-600 text-white',
  instagram: 'bg-gradient-to-r from-purple-500 to-pink-500 text-white',
};

const PLATFORM_LABELS: Record<SocialPlatform, string> = {
  twitter: 'X / Twitter',
  linkedin: 'LinkedIn',
  facebook: 'Facebook',
  instagram: 'Instagram',
};

interface PlatformBadgeProps {
  platform: SocialPlatform;
  size?: 'sm' | 'md';
}

export function PlatformBadge({ platform, size = 'sm' }: PlatformBadgeProps) {
  const colorClass = PLATFORM_COLORS[platform];
  const label = PLATFORM_LABELS[platform];
  const sizeClass = size === 'sm' ? 'text-xs px-2 py-0.5' : 'text-sm px-3 py-1';

  return (
    <span
      className={`inline-flex items-center rounded-full font-medium ${colorClass} ${sizeClass}`}
    >
      {label}
    </span>
  );
}
